import _ from "underscore";
import React from "react";
import PropTypes from "prop-types";
import { createComponent } from "@evertrue/et-flux";
import SessionSource from "apps/session/session-source";
import SsoSource from "apps/sso/sso-source";
import { Loading } from "@evertrue/et-components";
import MobileUtils from "utils/mobile-utils";

export default createComponent("SsoLoginController", {
  propTypes: {
    params: PropTypes.object,
  },

  componentDidMount() {
    const { params } = this.props;
    const code_is_defined = params && params.code && params.code !== "undefined";

    if (code_is_defined) {
      const device_id = MobileUtils.isMobile() ? MobileUtils.getDeviceIdFromStorage() : undefined;
      // Retrieve org_slug and application from localStorage (stored before SSO redirect)
      const org_slug = localStorage ? localStorage.getItem("et-accounts--org-slug") : null;
      const application = localStorage ? localStorage.getItem("et-accounts--application") : null;
      // Token exchange now happens server-side via /sso/token endpoint
      SsoSource.promise.fetchAccessToken(params.code, org_slug, application).then(tokens => {
        // Clean up the stored org_slug and application
        if (localStorage) {
          localStorage.removeItem("et-accounts--org-slug");
          localStorage.removeItem("et-accounts--application");
        }
        SessionSource.createSessionWithSsoTokens(tokens, device_id);
      });
    } else if (params && params.error) {
      const error_data = _.pick(params, "error", "error_description");
      SsoSource.setDeferredError("sso-login: error", error_data);
    } else {
      const error_description = "No authorization code provided";
      SsoSource.setDeferredError("sso-login: missing data", { error_description });
    }
  },

  render() {
    return (
      <div className="sso-login-controller">
        <Loading />
      </div>
    );
  },
});
